import { A11y } from "@churchofjesuschrist/eden-buttons";
import { accentColorPrimary, spacing32, spacing4, white } from "@churchofjesuschrist/eden-style-constants";
import styled from "styled-components";

const ColoredButton = styled(A11y)`
  color: ${({inverted = false}) => inverted ? white : accentColorPrimary};
`;

const SmallButton = styled(A11y)`
  box-sizing: border-box;
  background: ${({ background }) => background};
  border: ${({ color, inverted }) =>
  inverted ? `1px solid ${accentColorPrimary}` : `2px solid ${color}`};
  border-radius: 6px;
  height: ${({ height }) => height ? height : spacing32};
  position: relative;
  width: ${({ width }) => width};
  justify-content: center;
  display: inline-flex;
  align-items: center;
`;

const StyledWrapper = styled.span`
  font-size: 1.25rem;
  svg{
    margin-left:${spacing4};
  }
`;

const TextHolder = styled.span`
  display: inline-block;
  position: relative;
  top: -3px;
`;

export { ColoredButton, SmallButton, StyledWrapper, TextHolder };
